export { default } from './QuickPayWrapper';
